<!--学期管理-->
<template>
    <div>
        <div class="m-portlet left">
            <div class="m-portlet__body">
                <el-form>
                    <el-form-item>
                        <el-button style="width: 100%" @click="handleCreateSemester()">
                            创建学期
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="section_id" placeholder="筛选校区" clearable
                                   @change="handleIndexSemester(1,10)">
                            <el-option
                                    v-for="item in filter.sections"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>

        </div>
        <div class="m-portlet right" :style="{'height':(clientHeight-250)+'px'}">
            <div class="m-portlet__body">
                <table class="table" v-loading="loading">
                    <thead>
                    <tr>
                        <th>学期名</th>
                        <th>开始时间</th>
                        <th>结束时间</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in semesters" :key="index">
                        <td>{{item.name}}</td>
                        <td>{{item.start_date}}</td>
                        <td>{{item.end_date}}</td>

                        <td>
                            <el-button size="mini" @click="handleSemesterInformation(item.id)">查看学期</el-button>
                            <el-button size="mini" @click="handleDeleteSemester(item.id)" :loading="button_loading">
                                删除学期
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "students-list",
        data() {
            return {
                path: '/semesters',
                loading: true,
                button_loading: false,
                semesters: {},
                currentPage: 1,
                currentPageSize: 10,
                total: 1,
                section_id: '',
                filter: {
                    grades: [],
                    subjects: [],
                    sections: [],
                },
                dialog_GetSemesterDetail: {
                    semester: {
                        id: '',
                        name: '',
                        start_date: '',
                        end_date: '',
                        type: '1',
                    },
                    courses: [{
                        title: '',
                        id: '',
                        subjects: [{
                            id: '',
                            name: '',
                            period: '',
                            onePrice: '',
                            twoPrice: '',
                            threePrice: '',
                            sixPrice: '',
                            manyPrice: '',
                            row: '',
                            cohesionPrice: '',
                            cohesionPeriod: '',
                            tiPrice: '',
                            tiPeriod: '',
                        }],
                        row: 0,
                        key: '1'
                    }],
                    section_id: '',
                    loading: true,
                    button_loading: false,
                },
                dialog_CreateSemester: {
                    loading: true,
                    button_loading: false,
                    courses: [{
                        title: '',
                        name: '',
                        value: '',
                        subjects: [{
                            id: '',
                            name: '',
                            period: '',
                            onePrice: '',
                            twoPrice: '',
                            threePrice: '',
                            sixPrice: '',
                            manyPrice: '',
                            row: '',
                            cohesionPrice: '',
                            cohesionPeriod: '',
                            tiPrice: '',
                            tiPeriod: '',
                        }],
                        row: 0,
                        key: '1'
                    }],
                },
            }
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.handleCreate();
            this.handleIndexSemester();
            this.handleCreateCourse();
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'get_semesterList':
                        if (Object.keys(data.semesters).length > 0) {
                            this.semesters = data.semesters
                        } else {
                            this.semesters = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'get_semesterDetail':
                        this.dialog_GetSemesterDetail.courses = data.courses;
                        this.dialog_GetSemesterDetail.semester = data.semester;
                        this.dialog_GetSemesterDetail.section_id = data.section_id;
                        this.dialog_GetSemesterDetail.tabIndex = this.dialog_GetSemesterDetail.courses.length;
                        this.dialog_GetSemesterDetail.loading = false;
                        break;
                    case 'get_baseInfo':
                        this.filter.subjects = data.subjects;
                        this.filter.grades = data.grades;
                        this.filter.sections = data.sections;
                        this.dialog_GetSemesterDetail.courses = [];
                        if (Object.keys(data.courses).length > 0) {
                            this.dialog_CreateSemester.courses = data.courses
                        } else {
                            this.dialog_CreateSemester.courses = new Object();
                        }
                        break;
                    case 'update_semesterDetail':
                        this.$message({
                            message: '学期修改成功',
                            type: 'success'
                        });
                        this.$set(this.semesters, data.semester.id, data.semester);
                        this.dialog_GetSemesterDetail.button_loading = false;
                        break;
                    case 'update_semesterDetail_error':
                        this.dialog_GetSemesterDetail.button_loading = false;
                        break;
                    case 'store_semester':
                        this.$message({
                            message: '学期添加成功',
                            type: 'success'
                        });
                        this.dialog_CreateSemester.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'store_semester_error':
                        this.dialog_CreateSemester.button_loading = false;
                        break;
                    case 'delete_semester':
                        this.$message({
                            message: '学期删除成功',
                            type: 'success'
                        });
                        this.$delete(this.semesters, data);
                        this.button_loading = false;
                        break;
                    case 'delete_semester_error':
                        this.button_loading = false;
                        break;
                }
            },
            //获取基本年级，学科信息
            handleCreateCourse() {
                this.$wApi.send(this.path, 'get_baseInfo');
            },
            handleIndexSemester(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.path, 'get_semesterList', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'section_id': this.section_id,
                });
            },
            handleSemesterInformation(semester_id) {
                this.$Win.openModal('Dialog_GetSemesterDetail', 1000, 800, '学期详情', {
                    'semester_id': semester_id
                });
            },
            handleDeleteSemester(id) {
                this.button_loading = true;
                this.$confirm('是否删除该学期?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'delete_semester', {
                        'id': id,
                    });
                }).catch(() => {
                    this.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleCreateSemester() {
                this.$Win.openModal('Dialog_CreateSemester', 1000, 800, '创建学期');
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexSemester(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexSemester(this.currentPage, this.currentPageSize)
            }
        }
    }
</script>

<style scoped>
    .left {
        width: 200px;
        float: left;
    }

    .right {
        margin-left: 210px;
    }
</style>
